module.exports = __webpack_public_path__ + "static/hero-ca92f472b365560ec7b88858b33f8007.jpg";